module.exports = __webpack_public_path__ + "img/error.4ed627b3.png";